<div *ngFor="let item of items" class="cp-property-list">
	<div *ngIf="canDeleteJournalEntry(item)" class="float-end">
		<fa-icon [icon]="['fas', 'trash-alt']" class="text-danger" size="sm" placement="start" ngbTooltip="Delete this journal entry"
			(click)="deleteJournalEntry(item)"></fa-icon>
	</div>
	<div class="fw-bold">
		{{ item.added_on | date: ac.pageDateTimeFmt }} by {{ getUsersName(item.added_by) }}
	</div>
	<div class="cp-pre-text">{{ item.information.trim() }}</div>
</div>